import React from "react";

interface CheckoutStepperProps {
    currentStep: number;
}

const steps = ["Cart", "Address", "Payment"];

const CheckoutStepper: React.FC<CheckoutStepperProps> = ({ currentStep }) => {
    return (
        <div className="hidden flex items-center justify-center w-full">
            {steps.map((step, index) => {
                const isActive = index === currentStep;
                const isCompleted = index < currentStep;

                return (
                    <div key={index} className="flex items-center">
                        {/* STEP TEXT */}
                        <span
                            className={`
                                text-sm tracking-[4px] font-semibold transition-all duration-200
                                ${isActive ? "text-white border-b-2 border-white pb-1" : ""}
                                ${isCompleted ? "text-green-200" : ""}
                                ${!isActive && !isCompleted ? "text-gray-400" : ""}
                            `}
                        >
                            {step.toUpperCase()}
                        </span>

                        {/* DASH LINE */}
                        {index < steps.length - 1 && (
                            <div
                                className={`
                                    mx-3 w-10 border-t border-dashed
                                    ${index < currentStep ? "border-green-500" : "border-gray-400"}
                                `}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default CheckoutStepper;